export default "__VITE_ASSET__005fa9a8__"